import Icon from "@ant-design/icons";
import { ReactComponent as ProfileSvg } from "./svg/profile.svg";

const ProfileIcon = (props) => <Icon component={ProfileSvg} {...props} />;

export default ProfileIcon;
